import { DataGridSkeleton } from '@cw-ui/data-grid';
import { Stack } from '@mui/system';
import NonLoggedInAppBanner from 'src/components/AppBanner/NonLoggedInAppBanner';
import css from 'src/styles/App.scss';
import AsioNeonResponsiveThemeProvider from 'src/theme/AsioNeonResponsiveThemeProvider';
import { AppTabsPanelContainer } from '../AppTabsPanelContainer';
import * as Styles from './AppLoader.styles';

export const columns = [
    {
        field: 'f1',
        flex: 1,
    },
    {
        field: 'f2',
        flex: 1,
    },
    {
        field: 'f3',
        flex: 1,
    },
    {
        field: 'f4',
        flex: 1,
    },
    {
        field: 'f5',
        flex: 1,
    },
];

function AppLoader() {
    return (
        <AsioNeonResponsiveThemeProvider>
            <NonLoggedInAppBanner />
            <div className={css.wrap}>
                <Styles.TabsContainer className="tabs-container">
                    <Stack direction="row" spacing={2}>
                        <Styles.ActiveTab variant="rounded" className="active-tab" component="div">
                            <Styles.TabText className="item-text"></Styles.TabText>
                        </Styles.ActiveTab>
                        {[1, 2, 3, 4, 5].map(item => (
                            <Styles.NonActiveTab key={item} variant="rounded" className="non-active-tab">
                                <Styles.TabText className="item-text"></Styles.TabText>
                            </Styles.NonActiveTab>
                        ))}
                    </Stack>
                </Styles.TabsContainer>
                <AppTabsPanelContainer reduceHeightBy={16}>
                    <Styles.ContentContainer className="content-container">
                        <DataGridSkeleton columns={columns} rowLength={7} />
                    </Styles.ContentContainer>
                </AppTabsPanelContainer>
            </div>
        </AsioNeonResponsiveThemeProvider>
    );
}

export default AppLoader;
